module.exports = __webpack_public_path__ + "static/media/join-us-group-10@2x.a5b8b8dd.png";